import { InfoIcon } from 'lucide-react';

import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import { RecipProcHistory } from '../DataEntry/RecipProcHistory';

type RecipHistoryDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  recipId: string;
  recipTag: string;
  isClientRecip: boolean;
};

export function RecipHistoryDialog({
  open,
  onOpenChange,
  recipId,
  recipTag,
  isClientRecip,
}: RecipHistoryDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="md:max-w-4xl">
        <DialogHeader>
          <DialogTitle>Recip History — {recipTag}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          {isClientRecip ? (
            <div className="text-muted-foreground flex items-center gap-2 rounded-lg border p-4 text-sm">
              <InfoIcon className="h-4 w-4 shrink-0" />
              No TransOva procedure history is available for client-owned
              recipients.
            </div>
          ) : (
            <RecipProcHistory recipId={recipId} />
          )}
        </DialogBody>
        <DialogFooter showCloseButton />
      </DialogContent>
    </Dialog>
  );
}
